import type { TranslationSchema } from '../zh';

const common: TranslationSchema['common'] = {
  home: 'Home',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  detail: 'Details',
  search: 'Search',
  reset: 'Reset',
  confirm: 'OK',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  logout: 'Log out',
  enabled: 'Enabled',
  disabled: 'Disabled',
  yes: 'Yes',
  no: 'No',
  network_error: 'Network error, please try again later',
  language: 'Language'
};

export default common;
